import { Apis } from "../../lib/Apis";

export const useInteriorDesign = () => {
    const getInteriorDesign = async (setInteriorDesignData, setTotal, offset = 0, limit = 10, searchFilter = "", category_name = "") => {
        try {
            const params = {};
            if (searchFilter) {
                params.searchFilter = searchFilter;
            }
            if (category_name) {
                params.category_name = category_name;
            }
            const response = await Apis.getInteriorDesign(offset, limit, params);
            if (response?.status === 200) {
                setInteriorDesignData(response.data.data);
                const totalRecords = response.data.pagination?.totalRecords || response.data.data.length;
                setTotal(totalRecords);
                return response.data;
            } else {
                throw new Error(response?.data?.message || "Failed to fetch interior designs.");
            }
        } catch (error) {
            console.error("Error fetching interior design:", error);
            throw error;
        }
    };

    const createInteriorDesign = async (data) => {
        try {
            const response = await Apis.createInteriorDesign(data);
            return response.data;
        } catch (error) {
            console.error("Error creating interior design:", error);
            throw error;
        }
    };

    const updateInteriorDesign = async (id, data) => {
        try {
            const response = await Apis.updateInteriorDesign(id, data);
            return response.data;
        } catch (error) {
            console.error("Error updating interior design:", error);
            throw error;
        }
    };

    const deleteInteriorDesign = async (id) => {
        try {
            const response = await Apis.deleteInteriorDesign(id);
            return response.data;
        } catch (error) {
            console.error("Error deleting interior design:", error);
            throw error;
        }
    };

    const getInteriorDesignById = async (id, setInteriorData) => {
        try {
            const response = await Apis.getInteriorDesignById(id);
            setInteriorData(response.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching interior design by id:", error);
            throw error;
        }
    };
    const showInteriorDesignOnHomeScreen = async (interiorDesignId, homeScreen) => {
        try {
            const data = {
                interiorDesignId,
                homeScreen: homeScreen ? 1 : 0
            };
            const response = await Apis.addInteriorDesignToHomeScreen(data);
            return response;
        } catch (error) {
            console.error("Error updating home screen status:", error);
            return error;
        }
    };

    const updateInteriorDesignPosition = async (interiorDesignId, newPosition) => {
        try {
            const response = await Apis.updateInteriorDesignPosition({ interiorDesignId, newPosition });
            return response?.data;
        } catch (error) {
            console.error("Error updating interior design position:", error);
            throw error;
        }
    };

    return {
        getInteriorDesign,
        createInteriorDesign,
        updateInteriorDesign,
        deleteInteriorDesign,
        getInteriorDesignById,
        showInteriorDesignOnHomeScreen,
        updateInteriorDesignPosition,
    };
};